// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1413":"de49cc29","5453":"1606726a","7304":"ccf7da5b"}[chunkId] || chunkId) + "." + {"1368":"734ea81ec84dbdd3","1413":"3df7575a760d8fc2","5453":"ca0d13475ff9039d","5806":"a26083c05d39cf8f","7304":"1939c7086f077275","9691":"079659c51546edd0"}[chunkId] + ".js";
};